const doc = [({"ko":({"adminButtonHotelCheckIn":({"addGuest":"손님 추가", "addRoom":"객실 추가", "deleteGuest":"손님 삭제", "deleteRoom":"객실 삭제", "setUpMembership":"회원 설정"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;